import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Role, RolesResponse, UserGroupCreate } from './types'

export const submitCreateGroup = createEvent<UserGroupCreate>()

export const rolesMounted = createEvent()

export const closeModal = createEvent()

export const createGroup = fx<UserGroupCreate, void>({
  method: 'POST',
  url: '/user_group',
})

export const getRoles = fx<void, RolesResponse>({
  method: 'GET',
  url: '/role',
})

export const $roles = restore<Role[]>(
  getRoles.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: submitCreateGroup,
  fn: (user) => {
    return {
      url: `/user_group`,
      body: { ...user },
    }
  },
  target: createGroup,
})

export const $isSuccessCreate = restore(
  createGroup.doneData.map(() => true),
  false,
).reset(closeModal)

sample({
  //@ts-ignore
  clock: rolesMounted,
  fn: () => {},
  target: getRoles,
})
